import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { PromoPageContainer } from 'components/no-auth/common/PromoPageContainer/PromoPageContainer';
import FaqSection from 'components/no-auth/common/sections/FaqSection';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import { HeroSection } from 'components/no-auth/common/sections/HeroSection';
import { StepBlockSection } from 'components/no-auth/common/sections/StepBlockSection';
import { TilesSection } from 'components/no-auth/common/sections/TilesSection';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

import { TEAMTAILOR } from 'constants/UrlConstants';

import { removeScript } from 'helpers/DOM';

import fonts from 'theme/fonts';
import promoColors from 'theme/promoColors';
import promoMedia from 'theme/promoMedia';

const JobsContainer = styled.div`
    .teamtailor-jobs__job-wrapper {
        ${promoMedia.desktop1440} {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            column-gap: 24px;
        }
    }
    .teamtailor-jobs__job {
        box-shadow: ${promoColors.shadowLoose};
        border-radius: 16px;
        padding: 24px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        justify-self: center;
        width: 100%;
        box-sizing: border-box;
    }
    .teamtailor-jobs__job-title {
        font-size: 18px;
        line-height: 24px;
        color: ${promoColors.gray80};
        margin-bottom: 8px;

        ${promoMedia.desktop1440} {
            font-size: 21px;
            line-height: 28px;
        }
    }
    .teamtailor-jobs__job-info {
        font-size: 14px;
        line-height: 20px;
        color: ${promoColors.gray40};

        ${promoMedia.desktop1440} {
            font-size: 16px;
            line-height: 24px;
        }
    }
    .teamtailor-jobs__filters {
        display: flex;
        flex-direction: row;
        justify-content: center;
        column-gap: 32px;
        margin-bottom: 32px;
    }
    .teamtailor-jobs__select-wrapper {
        width: 50%;
        margin: 0;

        ${promoMedia.desktop1440} {
            width: 25%;
        }
    }
    .teamtailor-jobs__select {
        font-family: ${fonts.regular};
        width: 100%;
        font-size: 14px;
        padding: 8px;
        border-radius: 8px;
        cursor: pointer;

        ${promoMedia.desktop1440} {
            font-size: 16px;
        }
    }
`;

const CareerPage = (props) => {
    useEffect(() => {
        if (__isBrowser__) {
            const script = document.createElement('script');
            script.src = TEAMTAILOR;
            script.defer = true;
            document.body.appendChild(script);
        }
        return () => removeScript(TEAMTAILOR);
    }, []);

    return (
        <>
            <PromoPageContainer bgColor="eggshell03">
                {props.heroTitle && (
                    <HeroSection title={props.heroTitle} text={props.heroText} bgImg={props.heroBgImg} img={props.heroImg} data={props.heroData} />
                )}

                <ColoredSectionContainer bottomPadding>
                    {props.jobTitle && <HeadingSection title={props.jobTitle} />}
                    <JobsContainer>
                        <div
                            className="teamtailor-jobs-widget"
                            data-teamtailor-limit="20"
                            data-teamtailor-department-select="true"
                            data-teamtailor-location-select="true"
                            data-teamtailor-api-key="WDG8SB0kMI4vMyi8vVIHcHLsU0s0MWCdtaq5Wwno"
                        />
                    </JobsContainer>
                </ColoredSectionContainer>

                <ColoredSectionContainer bgColor={'purple5'} bottomPadding>
                    {props.headline1Title && <HeadingSection title={props.headline1Title} />}
                    {props.stepsTiles && <StepBlockSection data={props.stepsTiles} />}
                </ColoredSectionContainer>

                <ColoredSectionContainer>{props.tilesCareer && <TilesSection data={props.tilesCareer} loadingLazy responsive />}</ColoredSectionContainer>

                {props.faqTitle && props.questions && <FaqSection title={props.faqTitle} questions={props.questions} />}
            </PromoPageContainer>
        </>
    );
};
const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroText: state.extra?.strapiApi?.hero_block?.text,
        heroImg: state.extra?.strapiApi?.hero_block?.img,
        heroBgImg: state.extra?.strapiApi?.hero_block?.bgImg,
        heroData: state.extra?.strapiApi?.hero_block,

        jobTitle: state.extra?.strapiApi?.headline_jobs?.title,

        headline1Title: state.extra?.strapiApi?.headline1?.title,

        stepsTiles: state.extra?.strapiApi?.step_tiles,

        faqTitle: state.extra?.strapiApi?.faq?.title,
        questions: state.extra?.strapiApi?.faq?.questions,

        tilesCareer: state.extra?.strapiApi?.tiles_career,

        lang: state.extra.noAuthFooter?.language?.lang,
        country: state.extra.noAuthFooter?.language?.country,
    };
};
export default connect(mapStateToProps)(NotAuthBasePage(CareerPage));
